import { useRef } from "react"
import HeaderSearch from "./components/HeaderSearch"
import "./style.scss";
import { PrescriptiopnGlobalContext } from "../../../contexts/orden-medica/prescriptionContext";
import OrdenMedicaComponent from "../../../components/hb/ordenes-medicas";

const OrdenesMedicas = () => {
    const ref = useRef(null)
    return (
        <PrescriptiopnGlobalContext>
            <div className="d-flex help-page" ref={ref}>
                <OrdenMedicaComponent />
            </div>
        </PrescriptiopnGlobalContext>
    )
}

export default OrdenesMedicas